import Script from "next/script";
import { FC } from "react";

export const HatenaBookmarkButton: FC = () => {
  return (
    <div className="flex h-5 w-5 items-center justify-center overflow-hidden md:h-auto md:w-auto">
      <div className="scale-50 md:scale-75">
        <a
          href="https://b.hatena.ne.jp/entry/"
          className="hatena-bookmark-button"
          data-hatena-bookmark-layout="touch-counter"
          title="このエントリーをはてなブックマークに追加"
        >
          <img
            src="https://b.st-hatena.com/images/v4/public/entry-button/button-only@2x.png"
            alt="このエントリーをはてなブックマークに追加"
            width={20}
            height={20}
            style={{ border: "none" }}
          />
        </a>
        <Script
          type="text/javascript"
          src="https://b.st-hatena.com/js/bookmark_button.js"
          charSet="utf8"
          async
        ></Script>
      </div>
    </div>
  );
};
